import React from 'react'

import { createBrowserRouter } from 'react-router-dom'

import CommunitiesPage from '@pages/community/CommunityPage'
import Error404Page from '@pages/errors/Error404Page'
import UnexpectedErrorPage from '@pages/errors/UnexpectedErrorPage'
import HomePage from '@pages/home/HomePage'
import homeLoader, { homeRevalidator } from '@pages/home/loaders/home.loader'
import homeRoutes from '@pages/home/routes'
import BrowsePage from '@pages/music/BrowsePage'
import CategoriesPage from '@pages/music/CategoriesPage'
import MusicPage from '@pages/music/MusicPage'
import SearchPage from '@pages/music/SearchPage'
import categoriesLoader from '@pages/music/loaders/categories.loader'
import TitleDetailPage from '@pages/music/title/TitleDetailPage'
import TitleErrorPage from '@pages/music/title/TitleErrorPage'
import plansRoutes from '@pages/plans/routes'
import PageRoutes from '@utils/page-routes'

import Root from './Root'

import type { RouteObject } from 'react-router-dom'

export const routeConfig: RouteObject[] = [
  {
    path: '/',
    element: <Root />,
    errorElement: <Error404Page />,
    children: [
      {
        errorElement: <UnexpectedErrorPage />,
        children: [
          {
            id: 'homeRoot',
            path: PageRoutes.homePath(),
            element: <HomePage />,
            loader: homeLoader,
            shouldRevalidate: homeRevalidator,
            children: homeRoutes,
          },
          { path: PageRoutes.communityPath(), element: <CommunitiesPage /> },
          {
            path: PageRoutes.musicTitlePath(':id'),
            element: <TitleDetailPage />,
            children: [{ index: true, element: <TitleErrorPage /> }],
          },
          {
            path: PageRoutes.musicTitlePath(':id', ':slug'),
            element: <TitleDetailPage />,
            children: [{ index: true, element: <TitleErrorPage /> }],
          },
          {
            path: PageRoutes.musicCategoriesPath(),
            element: <CategoriesPage />,
            loader: categoriesLoader,
          },
          {
            path: PageRoutes.musicPath(),
            element: <MusicPage />,
            children: [
              { index: true, element: <BrowsePage /> },
              { path: 'search', element: <SearchPage /> },
              { path: ':slug', element: <SearchPage /> },
            ],
          },
          {
            path: PageRoutes.plansPath(),
            children: plansRoutes,
          },
        ],
      },
    ],
  },
]

const router = createBrowserRouter(routeConfig)
export default router
